import React from 'react';
import { Helmet } from 'react-helmet';

const PaymentGateway = () => {
  const paymentLink = "https://payments-test.cashfree.com/forms/maulicabs";




  const jsonData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Online Payment - Mauli Cabs",
    "url": "https://www.maulicabs.in/online-payment",  // Replace with actual URL
    "description": "Securely pay for your Mauli Cabs ride online. Choose from various payment methods to complete your booking for Mumbai to Pune trips, including credit card, debit card, UPI, and more."
  };
  

  
  return (


    
    <div className="payment-page">
        <Helmet>
    <title>Online Payment | Mauli Cabs | Secure Payment for Mumbai to Pune Taxi</title>
    <meta
      name="description"
      content="Make secure online payments for your Mauli Cabs booking. Pay conveniently for your Mumbai to Pune taxi ride with options like credit/debit cards, UPI, and more."
    />
    <meta
      name="keywords"
      content="online payment mauli cabs, secure payment mumbai pune taxi, cab booking payment, online payment taxi service, mauli cabs booking payment options, credit card payment mauli cabs, pay via UPI mauli cabs, debit card taxi payment, mumbai pune taxi online payment"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>

      <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title">Online Payment</h1>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className="payment-container">
        <div className="payment-card">
          <h2>Secure Payment</h2>
          <p>Click the button below to proceed to payment securely.</p>
          <a
            href={paymentLink}
            target="_blank"
            rel="noopener noreferrer"
            className="pay-button"
          >
            Pay Now
          </a>
          <p className="small-note">
            You will be redirected to a secure payment gateway.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PaymentGateway;
